module.exports = __webpack_public_path__ + "static/images/top-img-bg.fedb449.png";